// extracted by mini-css-extract-plugin
export var closeButton = "_lk-2";
export var closeButtonIcon = "_lk-3";
export var lightboxContent = "_lk-1";
export var lightboxOverlay = "_lk-0";